module.exports = __webpack_public_path__ + "media/images/shared/icon-member-ok-f4ce7a9cabff227685da1d07564404dc.png";